<script setup>
import Input from '@components/form/input.vue';
import { ref, watch } from 'vue';
import Icon from '@components/icons/icon.vue';
import { useRouterComposable } from '@router/router-composable';

const emit = defineEmits(['search']);
const searchString = ref(null);
const { currentRoute } = useRouterComposable();

watch(searchString, () => {
    emit('search', searchString.value);
});

watch(currentRoute, () => {
    searchString.value = null;
}, { deep: true });
</script>

<template>
    <div :class="$style.search">
        <Input
            v-model="searchString"
            :class="$style.input"
            no-borders
            no-focus-borders
            white-text-color
            placeholder="Suche"
        />
        <Icon
            :class="$style.button"
            icon="search"
            icon-color="white"
        />
    </div>
</template>

<style lang="scss" module>
@use '@backgrounds' as *;

.search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .85em 0 .35em;
    color: #fff;
    background-color: #4e5156;

    .input {
        max-width: 85%;

    }
    .button {
        cursor: pointer;

        > * {
            cursor: inherit;
        }
    }
}
</style>
